import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "product"
  }, [_vm._m(0), _c('div', {
    staticClass: "product-size"
  }, [_c('div', {
    staticClass: "size"
  }, [_c('h4', [_vm._v("种类")]), _c('div', {
    staticClass: "product-list"
  }, [_c('span', [_vm._v("标签宽度")]), _c('div', {
    staticClass: "taginp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.width,
      expression: "width"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入",
      "onkeyup": "value=value.replace(/[^\\d.]/g,'')"
    },
    domProps: {
      "value": _vm.width
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.width = $event.target.value;
      }
    }
  }), _c('em', [_vm._v("mm")])])]), _c('div', {
    staticClass: "product-list"
  }, [_c('span', [_vm._v("标签高度")]), _c('div', {
    staticClass: "taginp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.height,
      expression: "height"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入",
      "onkeyup": "value=value.replace(/[^\\d.]/g,'')"
    },
    domProps: {
      "value": _vm.height
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.height = $event.target.value;
      }
    }
  }), _c('em', [_vm._v("mm")])])])]), _c('div', {
    staticClass: "size size-list"
  }, [_c('h4', [_vm._v("定制张数")]), _c('div', {
    staticClass: "product-list"
  }, [_c('div', {
    staticClass: "taginp printsize"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.orderNum,
      expression: "orderNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入定制张数",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    domProps: {
      "value": _vm.orderNum
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.orderNum = $event.target.value;
      }
    }
  }), _c('em', [_vm._v("张")])])])])])]), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "product-img",
    on: {
      "click": _vm.showViewer
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectImg
    }
  }), _vm._m(1)]), _c('div', {
    staticClass: "product-size"
  }, [_vm._l(_vm.sizeList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "size"
    }, [_c('h4', [_vm._v(_vm._s(item.name))]), _c('ul', _vm._l(item.fileList, function (list, key) {
      return _c('li', {
        key: key,
        class: {
          'active': list.selected
        },
        on: {
          "click": function click($event) {
            return _vm.showProductImg(list.id, list.endProductType, index, key);
          }
        }
      }, [_vm._v(_vm._s(list.endProductTypeName))]);
    }), 0), index === 0 && _vm.packageTypeName === '卷筒装' ? _c('div', {
      staticClass: "diameter",
      on: {
        "click": function click($event) {
          _vm.isVisible = !_vm.isVisible;
        }
      }
    }, [_c('span', [_vm._v("卷芯直径:")]), _c('div', {
      staticClass: "diameter-select"
    }, [_c('span', [_vm._v(_vm._s(_vm.option))]), _c('i', {
      staticClass: "iconfont iconxiala"
    }), _vm.isVisible ? _c('div', {
      staticClass: "addresslist"
    }, [_c('div', {
      staticClass: "addresscont"
    }, _vm._l(_vm.listData, function (value, indexval) {
      return _c('div', {
        key: indexval,
        class: _vm.addIndex === indexval ? 'listcont active' : 'listcont',
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.selectDiameter(value.value, indexval);
          }
        }
      }, [_vm._v(_vm._s(value.value))]);
    }), 0)]) : _vm._e()])]) : _vm._e()]);
  }), _c('div', {
    staticClass: "next"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("上一步")]), _c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步（2/3)")])])], 2)])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer'), _c('div', {
    directives: [{
      name: "viewer",
      rawName: "v-viewer",
      value: {
        movable: false
      },
      expression: "{movable: false}"
    }],
    ref: "images",
    staticClass: "images"
  }, _vm._l(_vm.selectDetailsImg, function (item) {
    return _c('img', {
      key: item.id,
      attrs: {
        "src": item.sourceUrl
      }
    });
  }), 0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/tagimg.png")
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('i', {
    staticClass: "iconfont iconchakanxiangqing"
  })]);
}];
export { render, staticRenderFns };